import React from 'react';
import { withRouter } from 'react-router-dom';
import checkmark from '../../assets/images/checkmark.svg';
import animator from '../../helpers/animator';
import searchIcon from '../../assets/images/search-icon.svg';
import './PopupMenu.scss';

import BaseComponent from '../../baseClasses/BaseComponent';
import Input from '../Input';

export class PopupMenu extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { menuSearchRender: false, searchString: '', lastScrollPosition: 0, menuOptions: this.props.menuOptions };
    this.searchString = '';
    this.keyPressedMultiple = 0;
    this.selectedMenuItemIndex = -1;
    this.animator = new animator();
    this.blur = false;
    this.setFocus = this.setFocus.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if(this.state.menuOptions && newProps.menuOptions && this.state.menuOptions.length != newProps.menuOptions.length){
      console.log(newProps.menuOptions.length);
      this.setState({
        menuOptions: newProps.menuOptions,
      });
    }
  }

  componentDidUpdate(prevState) {
    if (prevState.menuOptions != this.props.menuOptions) {
      this.setState({ forceRedrawToggle: !this.state.forceRedrawToggle, menuOptions: this.props.menuOptions });
    }
    
    if (this.animator.hasAnimations) {
      // start the animation in a timer thread
      const self = this;
      setTimeout(() => {
        self.animator.processAnimationQueue(() => {
          self.handleFinishDisplay(true);
        });
      }, 10);
    }  
    else {
      this.setFocus();
    }
  }

  processSearchString(searchString) {
    this.selectedMenuItemIndex = -1;
    if (this.state.selectedMenuOption) {
      this.state.selectedMenuOption.keyboardSelected = false;
      this.disableHover = false;
    }

    const { menuOptions } = this.state;
    let smo = null;
    const saveFirstItem = menuOptions && menuOptions.length > 0 &&
      menuOptions[0].type == 0 ? menuOptions[0] : null;
    const searchOptions = this.props.menuOptions.filter((option, index) => {
      const foundOption = option.name.toLowerCase().indexOf(searchString) >= 0;
      if (foundOption && !smo) {
        smo = option;
      }
      return foundOption;
    });
    this.setState({ menuOptions: searchOptions });
    this.selectedMenuItemIndex = 0;
    if (saveFirstItem) {
      menuOptions.splice(0, 0, saveFirstItem);
      this.selectedMenuItemIndex++;
    }
    if (!smo && menuOptions.length > 0) {
      smo = menuOptions[0];
    }
    if (smo) {
      let arrayLoc = this.keyPressedMultiple < menuOptions.length ? this.keyPressedMultiple : menuOptions.length;
      smo = menuOptions[arrayLoc];
      smo.keyboardSelected = true;
      this.disableHover = true;
      this.ensureItemVisible('option-' + (smo.optionId != undefined ? smo.optionId : smo.type));
      this.setState({ selectedMenuOption: smo });
      this.selectMenuItem(smo.type, false, smo, true);
      this.resizeMenu();
    }
  }

  initializeMenu() {
    const { menuOptions } = this.state;
    this.menuContainer = document.getElementById(this.props.menuId);
    const rect = this.menuContainer.getBoundingClientRect();

    if (this.props.left >= 0) {
      this.menuContainer.style.left = (rect.left + (this.props.left < 0 && this.props.left > -10 ? this.props.left : 0)) + 'px';
    }

    const countSeparators = menuOptions.filter(op => {
      return op.separated;
    });

    const { showSearchBar } = this.props;
    let actualTop = 0;
    let actualBottom = 0;
    const optionHeight = this.props.size == 'largest' ? 52 : this.props.size == 'large' ? 45 : (this.props.size == 'small' ? 31 : 20);
    let actualHeight = (menuOptions.length * optionHeight) + optionHeight +
      (countSeparators.length * 5);

    this.endHeight = Math.min(actualHeight + (showSearchBar ? 1 : 0), (this.props.height ? this.props.height : (showSearchBar ? 338 : 300)));

    // Don't set this yet. Will be set by animator  
    //    this.menuContainer.style.height = this.endHeight + "px"

    if (this.props.top) {
      actualTop = rect.top;
      actualBottom = (window.innerHeight - actualTop) + this.props.top - 8;
      if (rect.height > 0 && rect.bottom - rect.top < this.endHeight) {
        actualTop = rect.bottom - this.endHeight - 28;
        actualTop += 6;
      }
      
      if (actualTop + this.endHeight > window.innerHeight) {
        this.menuContainer.style.bottom = (actualBottom + (this.props.showSearchBar ? 10 : 0)) + 'px';
        this.setState({ forgetTop: true });
      }
      else {
        if (this.props.multiSelect) {
          this.setState({ forgetTop: false });
        }
        this.menuContainer.style.top = actualTop + 'px';
        this.menuContainer.style.bottom = '';
      }
    }
    else if (this.props.bottom) {
      actualBottom += (window.innerHeight - rect.bottom) - this.props.bottom - 8;
      
      this.setState({ forgetTop: true });
      this.menuContainer.style.bottom = actualBottom + 'px';
    }
  }

  resizeMenu() {
    const { menuOptions } = this.state;
    this.menuContainer = document.getElementById(this.props.menuId);
    const countSeparators = menuOptions.filter(op => {
      return op.separated;
    });
    let actualHeight = (menuOptions.length * (this.props.size == 'largest' ? 52 : this.props.size == 'large' ? 45 :
      (this.props.size == 'small' ? 30 : 20))) + 12 +
      (countSeparators.length * 5);

    this.endHeight = Math.min(actualHeight, (this.props.height ? this.props.height : 300));
    this.menuContainer.style.height = (this.endHeight + 1) + 'px';
    this.setState({ menuHeight: this.endHeight });
  }

  relocateMenu() {
    this.menuContainer.remove();
    this.pageBackground.remove();
  }

  componentDidMount(){
    // TODO: refactor this to not be appended to body
    // pop the menu out to the body element
    const bodyElement = document.body;
    this.menuContainer = document.getElementById(this.props.menuId);
    this.pageBackground = document.getElementById('popup-background');
    if (this.pageBackground) {
      bodyElement.appendChild(this.pageBackground);
    }
    if (this.menuContainer) {
      this.initializeMenu();
      bodyElement.appendChild(this.menuContainer);
      if (this.animator.hasAnimations) {
        // start the animation in a timer thread
        const self = this;
        setTimeout(() => {
          self.animator.processAnimationQueue(() => {
            self.displayed = true;
            self.handleFinishDisplay(false);
          });
        }, 10);
      }

      if (this.props.initialValue) {
        this.searchString = this.props.initialValue ? this.props.initialValue.toLowerCase() : '';
        this.processSearchString(this.searchString);
      }
    }

    this.setFocus();
  }

  setFocus() {
    if (this.mainMenu) {
      this.mainMenu.setAttribute('tabIndex', Math.ceil(Math.random() * 100));
      this.mainMenu.focus();
    }
    if (this.searchInput) {
      this.searchInput.focus();
    }
  }

  handleFinishDisplay(dontMakeVisible) {
    this.blur = true;
    //this.mainMenu.addEventListener("blur", this.handleBlur)
    this.setFocus();
    if (this.props.showSearchBar && !dontMakeVisible) {
      if (this.outerPopup) {
        this.outerPopup.style.overflow = 'visible';
      }
    }
  }

  componentWillUnmount() {
    // this.mainMenu.removeEventListener("blur", this.handleBlur)

    if (!this.hidden) {
      this.animateHide(null, true);
    }
    this.relocateMenu();
  }

  ensureItemVisible(id) {
    let element = document.getElementById(id);
    if (element) {
      element.scrollIntoView();
      var parentElement = element.parentElement;
      var rect = element.getBoundingClientRect();
      var parentRect = parentElement.getBoundingClientRect();
      var scrollRect = this.mainMenu.getBoundingClientRect();
      if (rect.top <= scrollRect.top) {
        this.mainMenu.scrollTop = (parentRect.top - rect.top) - rect.height;
      }
      else if (rect.bottom >= scrollRect.bottom) {
        this.mainMenu.scrollTop = (scrollRect.top - parentRect.top) + rect.height;
      }
    }
  }  

  selectMenuItem(type, dismiss, menuOption, keyboardSelected) {
    if (type != 'no-op') {
      if (this.props.multiSelect) {
        if (menuOption) {
          if (menuOption.selected) {
            menuOption.selected = false;
          }
          else {
            menuOption.selected = true;
          }
          const selectedMenuOptions = this.state.menuOptions.filter(mo => {
            return mo.selected;
          });
          if (this.props.handleMultiMenuSelection) {
            this.props.handleMultiMenuSelection(selectedMenuOptions, menuOption);
          }
          this.setState({
            refresh: !this.state.refresh,
          });
        }
      }
      else {
        if (!dismiss) {
          if (this.props.handleMenuSelection) {
            this.props.handleMenuSelection(type, keyboardSelected, this.state.searchString);
          }
          this.blur = false;
          this.setState({
            refresh: !this.state.refresh,
          });
        }
        else {
          if (keyboardSelected) {
            if (this.props.handleMenuSelection) {
              this.relocateMenu();
              this.props.handleMenuSelection(type, false, this.state.searchString);
              if (this.props.handleClickAway) {
                this.props.handleClickAway(this.props.menuId, !type);
              }
            }
          }
          else {
            this.blur = true;
            this.setState({ showMenuPoup: false });
            this.animateHide(type);
          }
        }
      }
    }
  }

  handleMenuItemClick(e){
    e.stopPropagation();
    const type = e.target.getAttribute('data-id');
    if (type && type != 'no-op') {
      const value = e.target.getAttribute('data-dismiss');
      const menuItem = this.state.menuOptions.filter(menuOption => {
        return menuOption.type.toString() == type.toString();
      });
      const dismiss = (value == 'true');
      this.selectMenuItem(type, dismiss, menuItem.length > 0 ? menuItem[0] : null);
    
      this.setFocus();
    }
  }

  animateHide(type, immediate) {
    this.hidden = true;
    let { height, menuId, pointerPosition } = this.props;

    const element = document.getElementById(menuId);
    if (element) {
      height = parseInt(element.style.height.replace('px', ''), 10);
    }  
    if (pointerPosition == 'left') {
      const ani = this.animator.createPropertyAnimation(menuId, 150,
        { width: { startVal: this.endWidth, endVal: 0 } });
      this.animator.addAnimation(ani);
    }
    else {
      const ani = this.animator.createPropertyAnimation(menuId, 150,
        { height: { startVal: (height ? height : 200), endVal: 0 } });
      this.animator.addAnimation(ani);
    }

    if (immediate && element) {
      element.parentElement.removeChild(element);
      const clonedElement = element.cloneNode(true);
      const bodyElement = document.body;
      clonedElement.style.overflow = 'hidden';
      bodyElement.appendChild(clonedElement);
      this.animator.processAnimationQueue(() => {
        bodyElement.removeChild(clonedElement);
      }); 
    }
    else {

      // start the animation in a timer thread
      const self = this;
      setTimeout(() => {
        self.animator.processAnimationQueue(() => {
          if (self.props.handleMenuSelection && type) {
            self.props.handleMenuSelection(type, undefined, this.state.searchString);

          }
          self.props.handleClickAway(self.props.menuId, false);
        }, 10);
      });
    }

  }

  handleBlur(e) {
    if (this.blur) {
      this.animateHide(); 
    }
    else {
      if (this.mainMenu) {
        this.mainMenu.setAttribute('tabIndex', Math.ceil(Math.random() * 100));
        this.mainMenu.focus();
      }
      if (this.searchInput) {
        this.searchInput.focus();
      }
    }
    this.blur = false;
  }

  handleBackgroundClick(e) {
    e.stopPropagation();
    this.animateHide();
  }

  handleSearchInput(e) {
    this.setState({ searchString: e.target.value });
    if(this.props.handleSearchValue){
      this.props.handleSearchValue(e.target.value);
      return;
    }
    let searchOption;
    if (!e.target.value) {
      searchOption = this.props.menuOptions;
      this.setState({ menuOptions: searchOption });
    }
    else {
      searchOption = this.props.menuOptions.filter(option => {
        return option.name.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0;
      });
      this.setState({ menuOptions: searchOption });
      if (this.state.menuOptions.length == 0) {
        this.state.menuOptions.push({ type: 'no-op', name: 'No Results Found...' });
      }
    }
    this.searchString = e.target.value;
    if (this.searchInput) {
      this.searchInput.focus();
    }
  }

  handleSetScroller(e) {
    const div = e.target;
    const { lastScrollPosition } = this.state;

    const scrollChange = div.scrollTop - lastScrollPosition;

    const margin = 2;
    const isAtBottom = Math.abs(div.scrollTop + div.clientHeight - div.scrollHeight) <= margin;

    if (isAtBottom && scrollChange > 0) {
      this.props.handleAddOption(this.state.menuOptions);
    }
  }

  handleKeyDown(e) {
    if (this.props.multiSelect) {
      if (e.keyCode == 27) {
        e.stopPropagation();
        this.setState({ showMenuPoup: false });
        this.animateHide(null);
        if (this.props.handleClickAway) {
          this.props.handleClickAway(this.props.menuId);
        }
      }  
      return;
    }
    this.disableHover = false;
    let changedIt = false;
    if (e.keyCode == 8) {
      e.stopPropagation();
      if (this.searchString.length > 0) {
        this.searchString = this.searchString.substr(0, this.searchString.length - 1);
        changedIt = true;
      }
    }
    else if (e.keyCode == 13 || e.keyCode == 9) {
      e.stopPropagation();
      e.preventDefault();
      if (this.selectedMenuItemIndex >= 0 && this.selectedMenuItemIndex < this.state.menuOptions.length) {
        this.selectMenuItem(this.state.menuOptions[this.selectedMenuItemIndex].type, true, null, true);
      }
      this.selectedMenuItemIndex = -1;
    }
    else if (e.keyCode == 27) {
      e.stopPropagation();
      this.selectedMenuItemIndex = -1;
      this.blur = true;
      this.setState({ showMenuPoup: false });
      this.animateHide(null);
    }  
    // Up arrow  
    else if (e.keyCode == 38) {
      e.stopPropagation();
      e.preventDefault();
      if (this.selectedMenuItemIndex > 0) {
        if (this.state.selectedMenuOption) {
          this.state.selectedMenuOption.keyboardSelected = false;
        }
        this.selectedMenuItemIndex--;
        let smo = this.state.menuOptions[this.selectedMenuItemIndex]; 
        smo.keyboardSelected = true;
        this.disableHover = true;
        this.resizeMenu();        
        this.ensureItemVisible('option-' + (smo.optionId != undefined ? smo.optionId : smo.type));
        this.setState({ selectedMenuOption: smo });
        this.selectMenuItem(smo.type, false, smo, true);
      }
    } 
    // Down arrow  
    else if (e.keyCode == 40) {
      e.stopPropagation();
      e.preventDefault();
      if (this.selectedMenuItemIndex < this.state.menuOptions.length - 1) {
        if (this.state.selectedMenuOption) {
          this.state.selectedMenuOption.keyboardSelected = false;
          this.disableHover = false;
        }
        this.selectedMenuItemIndex++;
        let smo2 = this.state.menuOptions[this.selectedMenuItemIndex];
        smo2.keyboardSelected = true;
        this.disableHover = true;
        this.resizeMenu();
        this.ensureItemVisible('option-' + (smo2.optionId != undefined ? smo2.optionId : smo2.type));
        this.setState({ selectedMenuOption: smo2 });
        this.selectMenuItem(smo2.type, false, smo2, true);
      }      
    }  
    else if (!this.props.showSearchBar) {
      e.stopPropagation();
      if (e.key.length == 1) {
        if(this.searchString == e.key.toLowerCase()){
          this.keyPressedMultiple++;
        }else{
          this.keyPressedMultiple = 0;
          this.searchString += e.key.toLowerCase();
        }
        changedIt = true;
      }
    }

    if (changedIt && !this.props.showSearchBar) {
      this.processSearchString(this.searchString);
    }

    if (!!this.props.showSearchBar) {
      this.setFocus();
    }
  }

  handleLink(e) {
    e.stopPropagation();
    let link = null;
    let onClick = null;
    const type = e.target.getAttribute('data-id');
    for (var i = 0; i < this.state.menuOptions.length; i++){
      if (type == this.state.menuOptions[i].type) {
        link = this.state.menuOptions[i].link;
        onClick = this.state.menuOptions[i].onClick;
        break;
      }
    }
    if (link) {
      if(onClick){
        onClick(e, link);
      }
      else{
        this.props.history.push({ pathname: link });
      }
    }
  }

  render(){
    let { menuId, top, left, right, bottom, width, height, size, popupOnHover,
      pointerPosition } = this.props;

    this.state.menuSearchRender = false;

    if (this.state.forgetTop && !this.props.doNotForgetTop) {
      top = null;
    }

    const self = this;

    let menuOptionsFilter = this.state.menuOptions.filter(option => {
      return option.type;
    });
    let menuItems = menuOptionsFilter.map(option => {
      if (option.type == undefined){
        return null;
      }
      let keyboardSelectedClass = '';
      let dismiss = true;
      if (option.keyboardSelected) {
        keyboardSelectedClass = ' keyboard-selected';
      }
      else if (this.disableHover) {
        keyboardSelectedClass = ' disable-hover';
      }
      if (option.dismiss == false){
        dismiss = false;
      }

      const optionClassName = 'menu-option ' + (size != undefined ? size : 'large');
      const optionId = option.optionId != undefined ? option.optionId : option.type;
      const separatorClass = option.separated ? ' separated' : '';
      if (option.link != undefined) {
        if (option.icon != undefined){
          return(
            <div id={'option-' + optionId} className={optionClassName + keyboardSelectedClass} key={option.type} to={option.link}
              data-id={optionId} onClick={self.handleLink} >
                <img className="menu-icon" alt={option.name} src={option.icon} data-id={optionId}/>
              <p className="menu-text" data-id={optionId} data-dismiss={dismiss}>{option.name}</p>
              {option.subItem ? <div className='sub-item' data-id={optionId}>{option.subItem}</div>: null}
              {option.decoration && (<img alt="decoration" className="menu-decoration" src={option.decoration} />)}
              </div>
          );
        }
        else if (option.customIcon) {
          return (
            <div id={'option-' + optionId} className={optionClassName + keyboardSelectedClass} key={option.type} to={option.link}
              data-id={optionId} onClick={self.handleLink} >
              <div className="custom-menu-icon" data-id={optionId}>{option.customIcon}</div>
              <p className="menu-text" data-id={optionId} data-dismiss={dismiss}>{option.name}</p>
              {option.subItem ? <div className='sub-item' data-id={optionId}>{option.subItem}</div>: null}
              {option.decoration && (<img alt="decoration" className={'menu-decoration' + (this.props)} src={option.decoration} />)}
            </div>
          );
        }
        else if (option.customEmbeddedIcon) {
          return (
            <div id={'option-' + optionId} className={optionClassName + keyboardSelectedClass} key={option.type} to={option.link}
              data-id={optionId} onClick={self.handleLink} >
              {option.customEmbeddedIcon}
              <p className="menu-text" data-id={optionId} data-dismiss={dismiss}>{option.name}</p>
              {option.subItem ? <div className='sub-item' data-id={optionId}>{option.subItem}</div>: null}
              {option.decoration && (<img alt="decoration" className={'menu-decoration' + (this.props)} src={option.decoration} />)}
            </div>
          );
        }
        else{
          return(
            <div id={'option-' + optionId} className={optionClassName + keyboardSelectedClass + separatorClass} key={option.type} to={option.link}
              data-id={optionId} onClick={self.handleLink}>
                <p className="menu-text no-image" data-id={optionId} data-dismiss={dismiss}>{option.name}</p>
                {option.subItem ? <div className='sub-item' data-id={optionId}>{option.subItem}</div>: null}
                {option.decoration && (<img alt="decoration" className={'menu-decoration' + (this.props)} src={option.decoration} />)}
              </div>
          );
        }
      }
      else{
        if (option.icon != undefined) {
          return (
            <div id={'option-' + optionId} className={optionClassName + keyboardSelectedClass + separatorClass} key={option.type} onClick={self.handleMenuItemClick}
              data-id={optionId} >
              <img className="menu-icon" alt={option.name} src={option.icon} data-id={optionId} />
              <p className="menu-text" data-id={optionId} data-dismiss={dismiss}>{option.name}</p>
              {option.subItem ? <div className='sub-item' data-id={optionId}>{option.subItem}</div>: null}
              {option.decoration && (<img alt="decoration" className="menu-decoration" src={option.decoration} />)}
              {option.selected && (<img className={'selected-img' + (this.props.showSearchBar ? ' show-search-bar' : '')} src={checkmark} alt="selected" />)}
            </div>
          );
        }
        else if (option.customIcon) {
          return (
            <div id={'option-' + optionId} className={optionClassName + keyboardSelectedClass} key={option.type} to={option.link} onClick={self.handleMenuItemClick}
              data-id={optionId}  >
              <div className="custom-menu-icon" data-id={optionId}>{option.customIcon}</div>
              <p className="menu-text" data-id={optionId} data-dismiss={dismiss}>{option.name}</p>
              {option.subItem ? <div className='sub-item' data-id={optionId}>{option.subItem}</div>: null}
              {option.decoration && (<img alt="decoration" className="menu-decoration" src={option.decoration} />)}
              {option.selected && (<img className={'selected-img' + (this.props.showSearchBar ? ' show-search-bar' : '')} src={checkmark} alt="selected" />)}
            </div>
          );
        }
        else if (option.customEmbeddedIcon) {
          return (
            <div id={'option-' + optionId} className={optionClassName + keyboardSelectedClass} key={option.type} to={option.link} onClick={self.handleMenuItemClick}
              data-id={optionId}  >
              {option.customEmbeddedIcon}
              <p className="menu-text" data-id={optionId} data-dismiss={dismiss}>{option.name}</p>
              {option.subItem ? <div className='sub-item' data-id={optionId}>{option.subItem}</div>: null}
              {option.decoration && (<img alt="decoration" className="menu-decoration" src={option.decoration} />)}
              {option.selected && (<img className={'selected-img' + (this.props.showSearchBar ? ' show-search-bar' : '')} src={checkmark} alt="selected" />)}
            </div>
          );
        }
        else{
          return(
            <div id={'option-' + optionId} className={optionClassName + keyboardSelectedClass + separatorClass + ' tooltip-container'} key={'key-' + option.type} onClick={self.handleMenuItemClick}
                data-id={optionId} data-dismiss={dismiss} title={this.props.showTooltip ? option.name : ''}>
              <p className="menu-text no-image" data-id={optionId} data-dismiss={dismiss}>{option.name}</p>
              {option.subItem ? <div className='sub-item' data-id={optionId}>{option.subItem}</div>: null}
              {option.decoration && (<img alt="decoration" className="menu-decoration" src={option.decoration} />)}
              {option.selected && (<img className={'selected-img' + (this.props.showSearchBar ? ' show-search-bar' : '')} src={checkmark} alt="selected" />)}
            </div>
          );
        }
      }
    });

    const countSeparators = this.state.menuOptions.filter(op => { 
      return op.separated;
    }); 
    let actualHeight = (this.state.menuOptions.length * (size == 'largest' ? 52 : size == 'large' ? 45 : (size == 'small' ? 30 : 20))) +
      (countSeparators.length * 5);

    let style = {};
    let outerStyle = {};
    let innerStyle = { top: 0, left: 0 };
    if (top) {
      outerStyle.top = top - (!this.props.showSearchBar ? 10: 0);
    }
    else if (bottom != undefined) {
      outerStyle.bottom = bottom + 10;
    }
    if (left != undefined) {
      if (left + width + 20 > window.innerWidth) {
        left = window.innerWidth - width - (this.props.showSearchBar ? 0 : 20);
      }
      outerStyle.left = left - (this.props.showSearchBar ? 0 : 10);
    }
    if (right != undefined) {
      outerStyle.right = right + (this.props.showSearchBar ? 0 : 10);
    }
    if (width != undefined) {
      outerStyle.minWidth = width + (this.props.showSearchBar ? 0 : 20);
      style.minWidth = width - (this.props.showSearchBar ? 12 : 0);
      innerStyle.minWidth = width;
    }

    outerStyle.maxHeight = this.props.maxHeight ? this.props.maxHeight : null;
    style.maxHeight = this.props.maxHeight ? this.props.maxHeight : null;

    if (!this.endHeight) {
      this.endHeight = 0;
    
      this.endHeight = Math.min(Math.min(actualHeight, (height ? height :
        (top ? window.innerHeight - 250 - top :
          (bottom ? window.innerHeight - 250 - bottom : 300)))) + 10, 300) + 20;
    }
    // TODO: refactor these inline styles if possible
    if (this.props.overrideHeight) {
      style.height = Math.min(this.endHeight - 20, this.props.overrideHeight);
    }
    else {
      style.height = this.endHeight - (this.props.showSearchBar ? 19 : 20);
    }
    
    outerStyle.height = this.endHeight + (this.props.showSearchBar ? 43 : 0);

    let pointer = null;
    let baseClass = 'popup-menu-container' + (this.props.showSearchBar ? ' show-search-bar' : '');
    switch (pointerPosition) {
    case 'left':
      pointer = <div className={'pointer arrow-left' + (menuOptionsFilter.length == 1 ? ' single-line' : '')} />;  
      baseClass += ' arrow arrow-left';
      this.endWidth = width + 20;
      outerStyle.height = this.endHeight;
      outerStyle.width = 0;
      break;
    case 'right':
      pointer = <div className="pointer arrow-right" />;  
      baseClass += ' arrow arrow-right';
      break;
    case 'top':
      pointer = <div className="pointer arrow-up" />;  
      baseClass += ' arrow arrow-up';
      break;
    case 'top-right':
      pointer = <div className="pointer arrow-up-right" />;
      baseClass += ' arrow arrow-up';
      break;
    case 'bottom':
      pointer = <div className="pointer arrow-down" />;  
      baseClass += ' arrow arrow-down';
      break;
    default:
      break;
    }

    if (!this.displayed) {
      if (!this.props.initialValue) { 
        if (pointerPosition == 'left') {
          outerStyle.width = 0;  // change it to the starting value
          outerStyle.minWidth = 0;
          if (!this.animator.hasAnimations) {
            const ani = this.animator.createPropertyAnimation(menuId, 150,
              { width: { startVal: 0, endVal: this.endWidth } });
            this.animator.addAnimation(ani);
          }
        }
        else {
          outerStyle.height = 0;  // change it to the starting value
          if (!this.animator.hasAnimations) {
            const ani = this.animator.createPropertyAnimation(menuId, 150,
              { height: { startVal: 0, endVal: this.endHeight + (this.props.showSearchBar ? 43 : 0) } });
            this.animator.addAnimation(ani);
          }
        }
      } 
    }
    if(this.state.menuHeight){
      style.height = this.state.menuHeight;
      outerStyle.height = this.state.menuHeight;
    }

    innerStyle.top = 0;
    innerStyle.left = 0;
    const classNames = baseClass + ' ' + (popupOnHover != undefined && popupOnHover? 'hover-popup' : '');

    let backgroundStyle = {};
    if (this.props.backgroundIndex) {
      backgroundStyle = { zIndex: this.props.backgroundIndex };
    }
    let background = null;
    if (!this.props.noBackground) {
      background = <div id="popup-background" className="popup-background" style={backgroundStyle} onClick={this.handleBackgroundClick} ref={(element) => {
        this.outerMenu = element;
      }} >
      </div>;  
      
    }
    if(this.props.autoFocusSearchBar){
      outerStyle.minHeight = 220;
      innerStyle.minHeight = 170;
      style.minHeight =170;
      innerStyle.maxHeight=170;
    }
    return <div>
        {background}
      <div className={'outer-popup-container' + (this.props.showSearchBar ? ' show-search-bar' : '')} style={outerStyle} id={menuId} onScroll={(this.state.searchString === '') && this.props.handleAddOption && this.handleSetScroller}
        ref={element => {this.outerPopup = element;}}>
          {this.props.showSearchBar && <div className="combo-search-bar">
              <img className="search-icon" src={searchIcon} alt="search icon"/>
              <Input className="search-input" onChange={this.handleSearchInput} onKeyDown={this.handleKeyDown} value={this.state.searchString} placeholder={this.props.searchHint} ref={element => {
                this.searchInput = element;
              }} />
            </div>}
        <div className={classNames} style={style} data-id={menuId + '-outer'}>
            {pointer}
            <div id={'main-menu-' + menuId} className="menu-popup-inner" style={innerStyle}>
              <div className="menu-item-container" onKeyDown={!this.props.showSearchBar ? this.handleKeyDown : undefined} ref={element => {
                this.mainMenu = element;
              }}>
                {menuItems}
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
}

export default withRouter(PopupMenu);



// WEBPACK FOOTER //
// ./src/components/PopupMenu/index.js